import {
  ButtonComponent,
  ModalComponent,
  TextFieldComponent,
} from "@/components";
import React from "react";
import Image from "next/image";
import { Stack, Typography } from "@mui/material";
import { IMAGES, WEB_COLORS } from "@/lib/constants";

const DocumentEmailModals = ({
  openEmailModal,
  handleModal1,
  handleModal2,
  formik,
  openConfirmEmailModal,
}) => {
  return (
    <>
      <ModalComponent
        title={"Enter your e-mail"}
        open={openEmailModal}
        handleModal={handleModal1}
      >
        <Stack gap={2}>
          <Typography>
            Please enter your e-mail address to recieve a document
          </Typography>
          <TextFieldComponent
            required
            name="emailId"
            label="Email Address"
            onBlur={formik.handleBlur}
            value={formik.values.emailId}
            onChange={formik.handleChange}
            error={Boolean(formik.touched.emailId && formik.errors.emailId)}
            errorMessage={formik.touched.emailId && formik.errors.emailId}
          />
          <ButtonComponent
            onClick={() => {
              formik.handleSubmit();
              handleModal1(false);
            }}
          >
            Confirm
          </ButtonComponent>
        </Stack>
      </ModalComponent>
      <ModalComponent open={openConfirmEmailModal} handleModal={handleModal2}>
        <Stack alignItems={"center"} gap={2}>
          <Image src={IMAGES.emailSent} alt="Email Sent" />
          <Typography align="center">Email Sent</Typography>
          <Typography align="center" color={WEB_COLORS.textFadeColor}>
            We have sent your request and you will receive the email within 24
            hours
          </Typography>
          <ButtonComponent
            onClick={() => {
              handleModal2(false);
              handleModal1(false);
            }}
          >
            Go Back
          </ButtonComponent>
        </Stack>
      </ModalComponent>
    </>
  );
};

export default DocumentEmailModals;
